<div class="app-panel app-panel--nested">
  <div class="app-panel__header">
    <h4 class="app-panel__title">{{ i18n().t('checklistCreator.definition.numberTitle') }}</h4>
  </div>
  <div class="checklist-creator__definition-grid" [formGroup]="form()">
    <label class="app-field">
      <span class="app-field__label">{{ i18n().t('checklistCreator.fields.rangeMin') }}</span>
      <input type="number" formControlName="numberMin" />
    </label>
    <label class="app-field">
      <span class="app-field__label">{{ i18n().t('checklistCreator.fields.rangeMax') }}</span>
      <input type="number" formControlName="numberMax" />
    </label>
  </div>
</div>
